import { createReducer, on } from "@ngrx/store";
import { LearningTrackingState, initialLearningTrackingState } from "./learning-tracking.state";
import { IsEnableLearningTabByLearnerId, IsEnableLearningTabByLearnerIdError, IsEnableLearningTabByLearnerIdSuccess } from "./learning-tracking.actions";

export const LearningTrackingReducers = createReducer(
  initialLearningTrackingState,
  on(IsEnableLearningTabByLearnerId, (state, _): LearningTrackingState => {
    return {
      ...state,
      loading: true,
      isEnableLearningTab: null,
      error: null
    }
  }),
  on(IsEnableLearningTabByLearnerIdSuccess, (state, action): LearningTrackingState => {
    return {
      ...state,
      loading: false,
      isEnableLearningTab: action.isEnabledLearningTab,
    }
  }),
  on(IsEnableLearningTabByLearnerIdError, (state, action): LearningTrackingState => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  })
)